import { jsx } from "@emotion/react/jsx-runtime";
import { useContext } from "react";
import urlTransformerContext from "./urlTransformerContext.mjs";
function UrlTransformerProvider(_ref) {
  let {
    children,
    transformUrl: originalTransformUrl,
    ...restProps
  } = _ref;
  const {
    transformUrl: parentTransformUrl
  } = useContext(urlTransformerContext);
  let transformUrl = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return originalTransformUrl(...args, parentTransformUrl);
  };
  return /* @__PURE__ */jsx(urlTransformerContext.Provider, {
    value: {
      transformUrl,
      ...restProps
    },
    children
  });
}
export { UrlTransformerProvider as default };